var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalStepsImg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 36.6667L37.5002 33.4433V25.8333C37.5702 22.87 34.0318 20.2283 30.8335 17.5",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.365 29.1667L29.1133 24.8217C28.9237 24.6244 28.6969 24.4665 28.4461 24.3572C28.1952 24.2478 27.9252 24.1892 27.6516 24.1846C27.378 24.1801 27.1062 24.2297 26.8518 24.3306C26.5974 24.4315 26.3655 24.5817 26.1695 24.7726C25.9734 24.9635 25.817 25.1913 25.7094 25.4429C25.6017 25.6945 25.5448 25.9649 25.5421 26.2385C25.5394 26.5122 25.5908 26.7837 25.6934 27.0374C25.796 27.291 25.9478 27.5219 26.14 27.7167L30.8333 32.5001V35.0001C31.0885 36.491 31.6565 37.9111 32.5 39.1667",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 3.33337L2.50016 6.55671V14.1667C2.43016 17.13 5.9685 19.7717 9.16683 22.5",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63525 10.8334L10.8869 15.1784C11.0765 15.3757 11.3033 15.5336 11.5541 15.6429C11.805 15.7523 12.075 15.8109 12.3486 15.8155C12.6222 15.82 12.8941 15.7704 13.1484 15.6695C13.4028 15.5686 13.6347 15.4184 13.8308 15.2275C14.0268 15.0366 14.1832 14.8088 14.2909 14.5572C14.3985 14.3056 14.4554 14.0352 14.4581 13.7616C14.4609 13.4879 14.4095 13.2164 14.3068 12.9627C14.2042 12.7091 14.0525 12.4782 13.8603 12.2834L9.16692 7.50004V5.00004C8.9117 3.50908 8.34369 2.08905 7.50025 0.833374",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 13.42V38.3334C9.1665 38.5544 9.2543 38.7664 9.41058 38.9226C9.56686 39.0789 9.77882 39.1667 9.99984 39.1667H28.3332",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.16663H12.5",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8335 26.58V16.6666",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 25.8334H12.5",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20.8334H12.5",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.8334H12.5",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1668 7.50004C34.1668 8.81858 33.7758 10.1075 33.0433 11.2038C32.3108 12.3002 31.2696 13.1547 30.0514 13.6592C28.8332 14.1638 27.4928 14.2958 26.1996 14.0386C24.9064 13.7814 23.7185 13.1464 22.7861 12.2141C21.8538 11.2817 21.2188 10.0938 20.9616 8.80064C20.7044 7.50744 20.8364 6.16699 21.341 4.94882C21.8456 3.73064 22.7 2.68945 23.7964 1.95691C24.8927 1.22437 26.1816 0.833374 27.5002 0.833374",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 2.5L28.09 8.57667C28.0126 8.65427 27.9206 8.71584 27.8194 8.75785C27.7181 8.79986 27.6096 8.82149 27.5 8.82149C27.3904 8.82149 27.2819 8.79986 27.1806 8.75785C27.0794 8.71584 26.9874 8.65427 26.91 8.57667L25 6.66667",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStepsImg4);
export default __webpack_public_path__ + "static/media/legalStepsImg4.11b6af9ea70f97e0e66835a22dc6b124.svg";
export { ForwardRef as ReactComponent };